"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reactions_1 = require("../../stores/reactions");
var runReactionsTasks_1 = __importDefault(require("./runReactionsTasks"));
function restoreDislikedMediafile(mediafileId, streamId) {
    var action = function (dispatch, _) {
        dispatch((0, reactions_1.addDislikeTaskToPending)({
            streamId: streamId,
            id: mediafileId,
            type: "restore-dislike",
        }));
        dispatch((0, reactions_1.recalculateDislikes)());
        dispatch((0, runReactionsTasks_1.default)());
    };
    action.type = restoreDislikedMediafile.type;
    return action;
}
exports.default = restoreDislikedMediafile;
restoreDislikedMediafile.type = "restoreDislikedMediafile";
//# sourceMappingURL=restoreDislikedMediafile.js.map